export const attachmentChipStatuses = Object.freeze({
  pending: 'yellow',
  approved: 'green',
  rejected: 'red',
  pending_upload: 'yellow',
  expired: 'yellow',
  not_applicable: 'gray',
  about_to_expire: 'yellow',
  replacement_pending: 'blue-gray',
  replacement_scheduled: 'green',
  replacement_rejected: 'red'
})
